<div *ngIf="!isNew" style="margin-bottom: 1rem">
  <vdr-card [title]="'catalog.stockQuantities' | translate">
    <h4>{{ totalStock$ | async }}</h4>
  </vdr-card>
</div>
